import { createAsyncThunk } from '@reduxjs/toolkit';
import { storeResources } from '../../resources';
import { sendMessage } from '../../../services/chats';
import { IChatMessage, ISendMessagePayload } from '../../../services/chats/types';

interface IProps {
  payload: ISendMessagePayload;
}
export const ThunkSendMessage = createAsyncThunk<IChatMessage, IProps>(
  `${storeResources.CHATS}/sendMessage`,
  ({ payload }) => sendMessage(payload).then(res => res.data),
);
